define('glu/grid/manageColumns/manageColumns',['require','../../layout','hbs!./manageColumns.hbs','./manageColumnsMenu'],function(require) {
    'use strict';

    var Layout = require('../../layout'),
        tmpl = require('hbs!./manageColumns.hbs'),
        ManageColumnsMenu = require('./manageColumnsMenu');

    return Layout.extend({
        template: tmpl,
        className: 'grid-manage-columns',

        regions: {
            manageColumnsMenu: '#region-manage-columns-menu'
        },

        ui: {
            '$menuTrigger': '.grid-manage-column-menu-trigger'
        },

        events: {
            'click @ui.$menuTrigger': 'toggleManageColumnMenu'
        },

        initialize: function() {
            this.grid = this.options.grid;
            this.listenTo(this.grid, {
                'grid:columnResizeComplete': this.updateHeight,
                'grid:contentRendered': this.updateHeight
            });
        },

        toggleManageColumnMenu: function(e) {
            e.preventDefault();

            if (!this.manageColumnsLayout) {
                this.manageColumnsLayout = new ManageColumnsMenu({
                    collection: this.options.columns,
                    filterProcessor: this.options.filterProcessor,
                    topPosition: this.ui.$menuTrigger.height()
                });

                this.listenTo(this.manageColumnsLayout, 'close', this.removeManageColumnsLayout);
                return this.manageColumnsMenu.show(this.manageColumnsLayout);
            }

            this.removeManageColumnsLayout();
        },

        removeManageColumnsLayout: function() {
            if (!this.manageColumnsLayout) {
                return;
            }
            this.manageColumnsLayout.close();
            this.manageColumnsLayout = null;
        },

        updateHeight: function() {
            var $thead = this.grid.$('thead'),
                height;

            if (!$thead.length) {
                return false;
            }

            height = window.parseInt($thead[0].getBoundingClientRect().height);
            this.ui.$menuTrigger.height(height);
        }
    });
});

